import { Injectable } from "@angular/core";

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
}

const MENUITEMS = [
  { state:'dashboard', name: 'Dashboard', type: 'link', icon: 'av_timer' },
  { state: 'user-management/view-user', type: 'link', name: 'Users', icon: 'people_alt' },
  { state:'scoober', name: 'Scoober', type: 'link', icon: 'bike_scooter' },
  { state:'ride', name: 'Rides', type: 'link', icon: 'bike_scooter' },
  { state:'reward', name: 'Reward', type: 'link', icon: 'local_activity' },
  { state: 'setting', type: 'link', name: 'Settings', icon: 'assistant' },
];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
